import type { SchemaViewerFieldNumberProps } from "./schema-viewer-field-number.type";

import { InputNumber } from "antd";

export const SchemaViewerFieldNumber = ({
  schema,
  disabled,
  ...formItemProps
}: SchemaViewerFieldNumberProps) => {
  const { placeholder, min, max, readOnly } = schema;

  return (
    <InputNumber
      data-testid="inputNumber"
      placeholder={placeholder}
      min={min ?? Number.MIN_SAFE_INTEGER}
      max={max ?? Number.MAX_SAFE_INTEGER}
      style={{ width: "100%" }}
      disabled={disabled}
      readOnly={readOnly}
      {...formItemProps}
    />
  );
};
